var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _vm.items.length
            ? _c("div", { staticClass: "title" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.items.length) +
                    _vm._s(_vm.$ct("items-selected")) +
                    " "
                ),
              ])
            : _vm._e(),
          _c("app-product-sku-autocomplete", {
            attrs: { label: _vm.label },
            on: {
              input: function ($event) {
                return _vm.onProduct($event)
              },
            },
          }),
          _c(
            "w-scroll-view",
            { style: { maxHeight: "150px" }, attrs: { tag: "w-list" } },
            _vm._l(_vm.items, function (item) {
              return _c(
                "w-list-item",
                { key: item },
                [
                  _c(
                    "w-list-item-text",
                    [
                      _vm._v(" " + _vm._s(item)),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("remove-item"),
                              expression: "$ct('remove-item')",
                            },
                          ],
                          attrs: { flat: "" },
                          on: {
                            click: function ($event) {
                              return _vm.removeProduct(item)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }